import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static values = { bulkUpdateUrl: String };
  static targets = ['strategyRow'];

  connect() {
    this.strategyBeingDragged = null;
    this.dragOverElement = null;
  }

  strategyRowTargetConnected(row) {
    row.addEventListener('dragstart', (event) => {
      if (!event.target.classList.contains('strategy')) {
        return;
      }

      event.dataTransfer.effectAllowed = 'move';
      this.strategyBeingDragged = event.currentTarget;
    });
    row.addEventListener('dragover', (event) => {
      if (this.strategyBeingDragged == null) {
        return;
      }

      this.endDragEffect();
      this.dragOverElement = event.currentTarget;
      this.dragOverElement.classList.add('dragging-over');
      event.preventDefault();
    });
    row.addEventListener('dragend', (event) => {
      this.endDragEffect();
      event.preventDefault();
    });
    row.addEventListener('drop', (event) => {
      if (this.strategyBeingDragged == null) {
        return;
      }

      this.endDragEffect();
      this.reorderAssigned();
      this.strategyBeingDragged = null;
    });
  }

  endDragEffect() {
    if (this.dragOverElement != null) {
      this.dragOverElement.classList.remove('dragging-over');
    }
  }

  reorderAssigned() {
    let strategyIds = this.strategyRowTargets.map(
      (strategy) => strategy.dataset.strategyId
    );
    this.removeDraggedElement(strategyIds);
    this.insertDraggedElement(
      strategyIds,
      this.dragOverElement.dataset.strategyId
    );
    let formData = new FormData();
    strategyIds.forEach((strategyId) => {
      formData.append('strategy_ids[]', strategyId);
    });
    this.sendRequest('patch', this.bulkUpdateUrlValue, formData);
  }

  removeDraggedElement(list) {
    const element = this.strategyBeingDragged.dataset.strategyId;
    const start = list.indexOf(element);
    const deleteCount = 1;
    list.splice(start, deleteCount);
  }

  insertDraggedElement(list, referenceElement) {
    const element = this.strategyBeingDragged.dataset.strategyId;
    const start = list.indexOf(referenceElement);
    const deleteCount = 0;
    /*if (this.isPlaceholderPhoneShownAbove) {
      list.splice(start, deleteCount, element);
    } else {*/
    list.splice(start + 1, deleteCount, element);
    //}
  }

  sendRequest(type, url, data) {
    Rails.ajax({
      url: url,
      type: type,
      dataType: 'json',
      data: data,
      success: (event, _status, _xhr) => {
        this.element.innerHTML = event.htmlContent;
      }
    });
  }
}
